module.exports = __webpack_public_path__ + "img/setup_guidline5.b6301c3f.png";